import { ROLE_ACCOMMODATION_PROVIDER, ROLE_GUEST } from '@spa/shared/constants/roleTypes';

const ROLES = {
  [ROLE_ACCOMMODATION_PROVIDER]: 'landlord',
  [ROLE_GUEST]: 'tenant'
};

export const getEulerianRole = role => {
  const userRole = ROLES[role];
  if (!userRole) {
    return 'visitor';
  }

  return userRole;
};
